export const TRACKEEZ_VERSION = '2.0.0';

// HubSpot — référence uniquement, le script est chargé par Webflow
export const HUBSPOT_PORTAL_ID = '4788034';
export const HUBSPOT_REGION = 'eu1';
/** @deprecated — Webflow charge le script HubSpot via son custom code */
export const HUBSPOT_SCRIPT_URL = 'https://js.hs-scripts.com/4788034.js';

// Amplitude — référence uniquement, le snippet est chargé par Webflow
/** @deprecated — Webflow charge Amplitude via cdn.amplitude.com/script/{API_KEY}.js */
export const AMPLITUDE_API_KEY = 'f24d9546977e5a9ef2fc7f96cee50404';
/** @deprecated — Webflow charge le SDK, pas Trackeez */
export const AMPLITUDE_SDK_URL = 'https://cdn.amplitude.com/libs/analytics-browser-2.39.0-min.js.gz';

// Cookie
export const TRACKING_COOKIE_NAME = 'taleez_tracking';
export const COOKIE_EXPIRY_DAYS = 180;
export const TRACKING_COOKIE_VERSION = 3 as const;
// Budget d'octets pour la valeur ENCODÉE de taleez_tracking. Conservateur : sous le
// buffer nginx (~4 Ko) partagé avec les autres cookies du domaine. Ajustable.
export const MAX_COOKIE_BYTES = 3500;

// Session
export const NEW_SESSION_TIMEOUT_MINUTES = 30;

// Amplitude retry
export const AMPLITUDE_RETRY_MAX_ATTEMPTS = 10;
export const AMPLITUDE_RETRY_DELAY_MS = 500;

// Page categorization
export const BLOG_URL_PATTERN = '/blog/';
export const DASHBOARD_URL_PATTERN = '/dashboard/';
export const THANK_YOU_URL_PATTERN = '/contact/merci-';

// Newsletter
export const NEWSLETTER_UNSUB_URL_PATTERN = '/contact/inscription-nl';
export const NEWSLETTER_UNSUB_WEBHOOK_URL = 'https://hook.eu1.make.com/c27os2fck7on26fptvpjkcjazq6c6q9s';

// Candidat — thank you page des formulaires candidat (hors scope HubSpot)
export const CANDIDAT_TY_URL_PATTERN = '/contact/redirection-candidat';
